import Icon from '../components/Icon';

const Weather29 = Icon(
  'weather-29',
  <>
    <path
      fillRule="evenodd"
      d="M17.437 2.513a.75.75 0 0 1-.03.783 3.08 3.08 0 0 0 4.27 4.27.75.75 0 0 1 1.165.654 5.86 5.86 0 0 1-3.063 4.912c.609.795.971 1.777.971 2.851 0 2.721-2.325 4.854-5.1 4.854H5.26c-2.173 0-4.01-1.672-4.01-3.825 0-1.644 1.077-3.012 2.55-3.562.567-2.938 3.278-5.113 6.473-5.113q.446 0 .877.055a5.856 5.856 0 0 1 5.602-6.262.75.75 0 0 1 .685.383m-4.728 6.266a6.54 6.54 0 0 1 3.048 2.352 5.27 5.27 0 0 1 2.848.897 4.37 4.37 0 0 0 2.491-2.586q-.542.139-1.126.14a4.58 4.58 0 0 1-4.44-5.705 4.36 4.36 0 0 0-2.821 4.902m-7.492 5.33c.253-2.365 2.387-4.272 5.056-4.272 1.921 0 3.576.994 4.438 2.437a.75.75 0 0 0 .691.364q.123-.008.248-.008c2.03 0 3.6 1.542 3.6 3.353s-1.57 3.354-3.6 3.354H5.26c-1.428 0-2.51-1.082-2.51-2.325 0-1.057.776-1.992 1.892-2.253a.75.75 0 0 0 .575-.65"
      clipRule="evenodd"
    />
  </>
);

export default Weather29;
